<template>
    <div>
        <div>
            <img src="../../assets/mk体育(中国)官方网站 - mk sports/product/2.png" style="width: 100%;height: auto" alt="">
        </div>
        <div class="index-div-content product-info-div">
            <el-row  type="flex" class="product-info-div-flex">
                <el-col :xs="24" :sm="14">
                    <router-link to='/product/robot/cicada'><h3 class="font-24 product-header">挂轨智能巡检机器人</h3></router-link>
                    <router-link to='/product/robot/cicada'><h3 class="font-18 product-header">「标准版」</h3></router-link>
                    <p class="product-content"> mk体育智能输送机智能巡检系统以机器人为核心，整合视觉算法检测技术、音频检测处理技术、热成像识别处理技术、人工智能识别技术等，实现对输煤廊道、变电站场景和设备的全方位全自主智能巡检和实时监控。</p>
                    <router-link to='/product/robot/cicada'>
                    <el-button type="primary" class="button " style="width: 70px">
                        详情
                    </el-button></router-link>
                </el-col>
                <el-col :xs="24" :sm="10">
                    <div class="product-image-zoom">
                        <div class='magnify'>
                            <div class='large'></div>
                            <img src="../../assets/mk体育(中国)官方网站 - mk sports/product/8O0A42481.png" class='small'  alt="">
                        </div>
                       </div>
                   </el-col>
            </el-row>

        </div>
        <div class="index-div-content product-info-div">
            <el-row  type="flex" class="product-info-div-flex">
                <el-col :xs="24" :sm="14">
                    <router-link to='/product/robot/cicadama'><h3 class="font-24 product-header">挂轨智能巡检机器人</h3></router-link>
                    <router-link to='/product/robot/cicadama'><h3 class="font-18 product-header">「煤安版」</h3></router-link>
                    <p class="product-content"> mk体育智能输送机智能巡检系统以机器人为核心，整合视觉算法检测技术、音频检测处理技术、热成像识别处理技术、多传感器融合技术、人工智能识别技术等，实现对输煤廊道、变电站场景和设备的全方位全自主智能巡检和实时监控。</p>
                    <router-link to='/product/robot/cicadama'>
                    <el-button type="primary" class="button " style="width: 70px">
                        详情
                    </el-button></router-link>
                </el-col>
                <el-col :xs="24" :sm="10">
                    <div class="magnify">
                    <img src="../../assets/mk体育(中国)官方网站 - mk sports/product/8O0A4311.png"  alt=""></div></el-col>
            </el-row>

        </div>
        <div class="index-div-content product-info-div">
            <el-row  type="flex" class="product-info-div-flex">
                <el-col :xs="24" :sm="14">
                    <router-link to='/product/robot/ladybug'> <h3 class="font-24 product-header">趴轨智能巡检机器人</h3></router-link>
                    <router-link to='/product/robot/ladybug'> <h3 class="font-18 product-header">「标准版」</h3></router-link>
                    <p class="product-content">mk体育智能输送机智能巡检系统以机器人为核心，整合音频检测处理技术、热成像识别处理技术、人工智能识别技术等，实现对输煤廊道、输送廊道场景和设备的全方位全自主智能巡检和实时监控。</p>
                    <router-link to='/product/robot/ladybug'>  <el-button type="primary" class="button " style="width: 70px">
                        详情
                    </el-button></router-link>
                </el-col>
                <el-col :xs="24" :sm="10">         <div class="magnify"><img src="../../assets/mk体育(中国)官方网站 - mk sports/product/8O0A4269.png"  alt=""></div></el-col>
            </el-row>

        </div>















    </div>
</template>

<script>

    export default {
        name: "robot"
    }


</script>

<style scoped lang="scss">


</style>